import { createI18n } from 'vue-i18n';
import messages from './strings/index';

// Escape pipes
const msgs = JSON.parse(JSON.stringify(messages).replaceAll('|', "{'|'}"))

// A bit nasty as approach, but it works.
// Standard approach would be to keep the i18n
// files named like the various locales (en-US, en-GB, it-IT, de-DE, fr-FR...).
// By doing so the user can load his specific culture locale.
// Right now we are referring to the general culture, and no specificity
// of the language is considered.
const browserLang = navigator.language.split('-')[0];

// call with I18n option
const i18n = createI18n({
  locale: browserLang, // set locale
  fallbackLocale: 'en',
  messages: msgs, // set locale messages
  fallbackWarn: false,
  missingWarn: false,
  silentTranslationWarn: true
});

export default i18n;
